import { takeLatest, call, put } from 'redux-saga/effects';
import _ from 'lodash';

import {
  fetchTasksRoutine,
  fetchTaskRoutine,
  saveTaskAssignmentsRoutine,
  editTaskRoutine,
  removeTasksRoutine,
  uploadTasksRoutine,
  sendTaskSmsRoutine,
  sendTaskEmailRoutine,
} from '../routines';
import { fetchSaga, saveSaga } from './helper';
import { showError } from '../actions/dialogs';
import { post } from '../../utils/request';
import { getAccountPath } from '../../utils/firebase';

// TODO remove
const update = () => {
}

function* watchFetchTasksSaga() {
  yield takeLatest(fetchTasksRoutine.TRIGGER, fetchSaga(fetchTasksRoutine, (payload) => getAccountPath('jobs', `${payload.jobId}/tasks`))); // TODO review url - need jobid
}

function* watchFetchTaskSaga() {
  yield takeLatest(fetchTaskRoutine.TRIGGER, fetchSaga(fetchTaskRoutine, (payload) => getAccountPath('tasks', payload.id)));
}

// function uploadTasks(job, tasks, taskProfile) {
//   const path = `/v1/accounts/${getAccountId()}/jobs/${job.id}/tasks`;
//   return post(path, {
//     method: 'POST',
//     headers: {
//       'Content-Type': 'application/json',
//       Accept: 'application/json',
//     },
//     body: JSON.stringify({ tasks, taskProfile }),
//   }).then((resp) => {
//     return resp;
//   }).catch((err) => {
//     throw new Error(err.message);
//   });
// }
//
// function* uploadTasksSaga(action) {
//   try {
//     yield put(uploadingTasks(action.job, action.tasks));
//     const tasks = yield call(uploadTasks, action.job, action.tasks, action.taskProfile);
//     yield put(uploadTasksSuccess(action.job, tasks));
//   } catch (e) {
//     console.error('Failed to upload tasks', e);
//     yield put(showError('Error', 'Failed to upload tasks'));
//     yield put(uploadTasksFailed(action.job, e));
//   }
// }

function* watchUploadTasksSaga() {
  // yield takeLatest(UPLOAD_TASKS, uploadTasksSaga);
  yield takeLatest(uploadTasksRoutine.TRIGGER, saveSaga(uploadTasksRoutine,
    (payload) => getAccountPath('jobs', `${payload.job.id}/tasks`), ///v1/accounts/${getAccountId()}/jobs/${payload.job.id}/tasks`,
    () => post,
    (payload) => ({
      tasks: payload.tasks,
      taskProfile: payload.taskProfile,
    })))
}

// function* saveTaskAssignmentsSaga(action) {
//   console.log('saveTaskAssignmentsSaga', 'saving tasks', action.payload);
//   const assignments = action.payload.reduce((res, task) => {
//     const stages = _.keys(task.stages).reduce((res2, stageId) => {
//       if (task.stages[stageId].assignedTo) {
//         return _.assign(res2, { assignedTo: task.stages[stageId].assignedTo });
//       }
//
//       return res2;
//     }, {});
//     return _.assign(res, { [task.id]: { stages } });
//   }, {});
//
//   console.log('assignments', assignments);
//
//   return updateSaga(saveTaskAssignmentsRoutine, () => getAccountPath('tasks'));
//
//   // try {
//   //   yield put(uploadingTasks(action.job, action.tasks));
//   //   const tasks = yield call(uploadTasks, action.job, action.tasks);
//   //   yield put(uploadTasksSuccess(action.job, tasks));
//   // } catch (e) {
//   //   console.error('Failed to upload tasks', e);
//   //   yield put(uploadTasksFailed(e));
//   // }
// }

function* watchSaveTaskAssignmentsSaga() {
  yield takeLatest(saveTaskAssignmentsRoutine.TRIGGER, saveSaga(saveTaskAssignmentsRoutine, () => getAccountPath('tasks'), (tasks) => {
    console.log('saveTaskAssignmentsSaga', 'saving tasks', tasks);
    const assignments = tasks.reduce((res, task) => {
      _.keys(task.stages).forEach((stageId) => {
        if (task.stages[stageId].assignedTo) {
          res[`${task.id}/stages/${stageId}/assignedTo`] = task.stages[stageId].assignedTo;
        }
      });
      return res;
    }, {});

    console.log('assignments', assignments);

    return assignments;
  }));
}

function* watchRemoveTasksSaga() {
  yield takeLatest(removeTasksRoutine.TRIGGER, saveSaga(removeTasksRoutine, () => 'tasks', ({ tasks }) => {
    console.log('removeTasksSaga', tasks);
    const removals = tasks.reduce((res, task) => {
      res[task.id] = { deleted: { at: new Date().toISOString() } };
      return res;
    }, {});

    console.log('removals', removals);

    return removals;
  }));
}

function saveTask(task) {
  return update(`/tasks/${task.id}`, task)
    .then(() => task);
}

function* editTaskSaga(action) {
  const task = action.payload.toJS();
  try {
    // trigger request action
    yield put(editTaskRoutine.request(task));
    // perform request to '/some_url' to fetch some data
    const response = yield call(saveTask, task);
    // if request successfully finished
    yield put(editTaskRoutine.success({ success: true, task: response }));
  } catch (err) {
    console.error('Unable to save task', err);
    yield put(editTaskRoutine.failure({ success: false, error: err.message }));
    yield put(showError('Error', 'Failed to update task'));
  } finally {
    // trigger fulfill action
    yield put(editTaskRoutine.fulfill());
  }
}

function* watchEditTaskSaga() {
  yield takeLatest(editTaskRoutine.TRIGGER, editTaskSaga);
}

function* watchSendTaskSmsSaga() {
  yield takeLatest(sendTaskSmsRoutine.TRIGGER, saveSaga(
    sendTaskSmsRoutine,
    (payload) => `${getAccountPath('jobs', payload.values.getIn(['params', 'job', 'id']))}/tasks/${payload.values.getIn(['params', 'task', 'id'])}/sendsms`,
    () => post,
    (payload) => ({ message: payload.values.get('body') })
  ));
}

function* watchSendTaskEmailSaga() {
  yield takeLatest(sendTaskEmailRoutine.TRIGGER, saveSaga(
    sendTaskEmailRoutine,
    (payload) => `${getAccountPath('jobs', payload.values.getIn(['params', 'job', 'id']))}/tasks/${payload.values.getIn(['params', 'task', 'id'])}/sendemail`,
    () => post,
    (payload) => ({ subject: payload.values.get('subject'), message: payload.values.get('body') })
  ));
}

export {
  watchFetchTasksSaga,
  watchFetchTaskSaga,
  watchUploadTasksSaga,
  watchSaveTaskAssignmentsSaga,
  watchEditTaskSaga,
  watchRemoveTasksSaga,

  watchSendTaskSmsSaga,
  watchSendTaskEmailSaga,
};



// WEBPACK FOOTER //
// ./src/redux/sagas/tasks.js